export const systemSettingsFrag = `
    synchronizationEnabled
`;
